<template>
  <div class="wpd-main">
    <div class="bg-container">
      <img src="@/assets/images/wpd/bg.svg">
    </div>

    <div class="heading">Celebrating <strong>World Prematurity Day</strong></div>
    <img class="labour-love" src="@/assets/images/labour-love-2.svg">

    <wpd-bear class="bear"/>

    <div class="wpd-names">
      <wpd-name
        v-if="$store.getters.activeSlide.babies.length >= 1"
        class="wpd-name1"
        :text="`${$store.getters.activeSlide.babies[0].firstname} ${!$store.getters.activeSlide.babies[0].middlename ? '' : $store.getters.activeSlide.babies[0].middlename} ${$store.getters.activeSlide.babies[0].lastname}`"></wpd-name>
      <wpd-name
        v-if="$store.getters.activeSlide.babies.length >= 2"
        class="wpd-name2"
        :text="`${$store.getters.activeSlide.babies[1].firstname} ${!$store.getters.activeSlide.babies[1].middlename ? '' : $store.getters.activeSlide.babies[1].middlename} ${$store.getters.activeSlide.babies[1].lastname}`"></wpd-name>
      <wpd-name
        v-if="$store.getters.activeSlide.babies.length >= 3"
        class="wpd-name3"
        :text="`${$store.getters.activeSlide.babies[2].firstname} ${!$store.getters.activeSlide.babies[2].middlename ? '' : $store.getters.activeSlide.babies[2].middlename} ${$store.getters.activeSlide.babies[2].lastname}`"></wpd-name>
      <wpd-name
        v-if="$store.getters.activeSlide.babies.length >= 4"
        class="wpd-name4"
        :text="`${$store.getters.activeSlide.babies[3].firstname} ${!$store.getters.activeSlide.babies[3].middlename ? '' : $store.getters.activeSlide.babies[3].middlename} ${$store.getters.activeSlide.babies[3].lastname}`"></wpd-name>
    </div>
  </div>
</template>

<script>
import { TimelineMax, Power3, Power4 } from 'gsap'
import WpdName from './WpdSlide/WpdName.vue'
import WpdBear from './WpdSlide/WpdBear.vue'
import SplitText from '@/assets/gsap-bonus/SplitText'

export default {
  name: 'WpdMain',

  components: { WpdName, WpdBear },

  data () {
    return {
      tl: new TimelineMax()
    }
  },
  mounted () {
    const bear = this.$el.querySelector('.bear')
    const haeding = this.$el.querySelector('.heading')
    const headingSplit = new SplitText(haeding, { type: 'words' })
    const brushes = this.$el.querySelectorAll('.wpd-name path')

    this.tl
      .delay(1.2)
      .add('start')
      .from(bear, 1.5, { yPercent: 200, ease: Power4.easeOut }, 'start+=0.5')
      .staggerFrom(headingSplit.words, 2.0, { yPercent: 100, ease: Power3.easeOut }, 0.1, 'start')
      .add('names')
      .staggerFrom(brushes, 1.3, { scaleX: 0, transformOrigin: 'left', ease: Power4.easeOut }, 0.3, 'names-=1')
  },
  watch: {
    '$store.state.activeSlide' (newValue, oldValue) {
      this.tl.seek('names-=0.6')
      this.tl.play()
    }
    // '$store.state.preload' (newValue, oldValue) {
    //   if (!newValue) {
    //     this.tl.play()
    //   }
    // }
  },
  beforeDestroy () {
    this.tl.kill()
  }
}
</script>

<style scoped>
  .bg-container {
    background: #634696;
  }

  .bg-container img {
    width: 100vw;
    height: 100vh;
    object-fit: cover;
  }

  .heading {
    font-family: 'Barlow', sans-serif;
    font-weight: 300;
    color: #ffffff;
    position: absolute;
    top: 0.3vw;
    font-size: 5.8vw;
    width: 100%;
    text-align: center;
    overflow: hidden;
    line-height: 2;
  }

  .heading strong {
    font-weight: 500;
  }

  .labour-love {
    position: absolute;
    left: 4.35vw;
    bottom: 3.5vw;
    width: 7.5vw;
    height: auto;
  }

  .wpd-names {
    position: absolute;
    top: 0;
    left: 0;
    width: 31vw;
  }

  .wpd-names * {
    position: absolute;
    width: 31vw;
    left: 20vw;
  }

  .wpd-name1 {
    top: 15.7vw;
  }

  .wpd-name2 {
    top: 23.7vw;
  }

  .wpd-name3 {
    top: 31.7vw;
  }

  .wpd-name4 {
    top: 39.7vw;
  }

  .bear {
    position: absolute;
    top: 12.3vw;
    right: 17.2vw;
    width: 56vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/WpdSlide.vue